import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Login from "../components/Login/Login";
import {
  fetchAccessToken,
  verifyOtp,
  resendOtp,
  fetchUserInfo
} from "../actions/user";

const mapStateToProps = (state) => {
  const { login } = state;
  const {
    isFetching,
    sessionId,
    accessToken,
    refreshToken,
    errorMessage,
    authority_class,
    admin_name, user_info,
    otpAttemptCount
  } = login || {
    isFetching: false,
    sessionId: null,
    accessToken: null,
    refreshToken: null,
    errorMessage: null,
    authority_class: null,
    admin_name: null,
    user_info: null,
    otpAttemptCount: 0
  };

  return {
    isFetching,
    sessionId,
    accessToken,
    refreshToken,
    errorMessage,
    authority_class,
    admin_name,
    user_info,
    otpAttemptCount
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchAccessToken,
      verifyOtp,
      resendOtp,
      fetchUserInfo
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Login);
